import React from "react";
import { saveLogin, saveLogout } from '../../utils/api/login'
import { getApplyTransactionCheck, sendNationCaptcha, checkCaptcha, doRegister, forgetPassword, getMyContracts } from '../../utils/api'
import { idCardValid, isHKCard, isTWCard, isPassPortCard, isOfficerCard, isAccountCard } from '../../config/identityCheck'
import { connect } from "react-redux";
import actionWays from '../../redux/actions';
import { withRouter } from 'react-router-dom'
import { MenuUnfoldOutlined, ExclamationCircleFilled,DownOutlined } from '@ant-design/icons';
import { userInfoFunc } from '../../config/func'
import { Imgbo, PAGE_NAME, USERVALIDTIME } from '../../config'
import { message, Modal, Form, Input, Button, Checkbox, Row, Col, Spin, Drawer, Select, Tooltip, Card, Cascader, Dropdown, Space } from "antd";
import { city } from '../../config/city'
import { cityShangHai } from '../../config/cityShangHai'
import ModalBox from '../../config/modalBox'
const { Option } = Select;
const homeTop = [    //登录以前
    { name: '首页', links: '/home' },
    { name: '房源项目', links: '/project' },
    { name: '政策法规', links: '/policy' },
    { name: '办事指南', links: '/workGuide' },
    { name: '续租申请', links: '' },
    // v4.1.2代码注释
    // { name: '区筹资格申请', links: '/areatoraise' },
    { name: '关于我们', links: '/aboutUs' },
    // { name: '资格申请', links: '' },
    { name: '登录', links: '' },
    { name: '注册', links: '' },
]
const homeTopLogin = [    //登录以后
    { name: '首页', links: '/home' },
    { name: '房源项目', links: '/project' },
    { name: '政策法规', links: '/policy' },
    { name: '办事指南', links: '/workGuide' },
    { name: '续租申请', links: '' },
    { name: '关于我们', links: '/aboutUs' },
    { name: '个人中心', links: '/personal' },
    { name: '退出', links: '' },
]


class Top extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            needFixed: false,
            currentIndex: localStorage.currentIndex ? localStorage.currentIndex : '/home',
            isModalVisible: false,
            isChangePassword: false,
            loading: false,
            personal: userInfoFunc(props.userLoginInfo) ? '1' : '0',
            loginLoading: false,
            signView: false,
            timer: 60,
            showInter: true,
            drawerVisible: false,
            checksFunc: '1',
            isApplyFor: false,
            applyForShow: false,
            showFlag: this.props?.userLoginInfo?.idno ? true : false,
            secondsToChecked: false,
            showInFlag: false,
            showCheckFlag: false,
            showMove: false,
            showRenewalModalBox: false,
            renewalContract: null,
        }
        this.timers = null
        this.workerGuideList = [
            {
              key: '1',
              label: (<a onClick={() => this.goGuide('apply')}>申请条件</a>)
            },
            {
              key: '2',
              label: (<a onClick={() => this.goGuide('guide')}>租赁指南</a>)
            },
            {
              key: '3',
              label: (<a onClick={() => this.goGuide('download')}>资料下载</a>)
            },
            {
              key: '4',
              label: (<a onClick={() => this.goGuide('faq')}>常见问题</a>)
            },
          ];
    }
    componentDidMount() {
        const { currentIndex } = this.state
        // if (!userInfoFunc(this.props.userLoginInfo)) {
        //     message.error('请先登录')
        // }
        window.addEventListener('scroll', this.handleScroll);
        console.log(this.props.location.pathname)
        // debugger
        if (userInfoFunc(this.props.userLoginInfo)) {
            if (this.props.location.pathname != '/belows') {
                for (let i in homeTopLogin) {
                    if (homeTopLogin[i].links == this.props.location.pathname) {
                        this.setState({
                            currentIndex: homeTopLogin[i].links
                        })
                    }
                }
            }
            // this.getTransactionTodoList()
        } else {
            for (let i in homeTop) {
                if (homeTop[i].links == this.props.location.pathname) {
                    this.setState({
                        currentIndex: homeTop[i].links
                    })
                }
            }
        }
        // console.log(localStorage.currentIndex)
        // this.elect(currentIndex, homeTop[currentIndex].links)
        if (this.props.onRegisterOpenLogin) {
            this.props.onRegisterOpenLogin(this.openLoginModal)
        }
        this.user_time()
    }
    componentWillUnmount() {
        clearInterval(this.timers)
        this.setState = () => false;
    }
    getTransactionTodoList = async () => {
        // let list = await getTransactionTodoList({ idno: this.props.userLoginInfo.idno })
        let list = await getTransactionDetailById({ id: '46715' })
        if (list.code == 0) {
            const dataList = list.data
            if (dataList.province) {
                if (!(dataList.province instanceof Array)) {
                    dataList.province = JSON.parse(dataList.province)
                }
            }
            dataList.province = dataList.province ? dataList.province instanceof Array ? dataList.province : [dataList.province, dataList.city, dataList.district] : undefined
            // 共同申请人
            for (let i in dataList.transactionPersonBeanList) {
                if (!dataList.transactionPersonBeanList[i]) {
                    dataList.transactionPersonBeanList = []
                    break
                }
                dataList.transactionPersonBeanList[i].id = i
            }
            // console.log(dataList);
            this.refs.showFlagRef.setFieldsValue(dataList)
            this.setState({
                dataList: dataList,
                registeredType: dataList.registeredType,
                sqTypes: dataList.applyAttruble,
            })
        } else {
            message.error(list.message)
        }
    }
    Cascader = (v) => {
        const dataList = this.state.dataList
        if (v[0] == '上海市') {
            dataList.registeredType = '本市'
            this.refs.showFlagRef.setFieldsValue(dataList)
        }
    }
    user_time = () => {
        if (this.props.userLoginInfo) {
            //获取用户登录时间
            let strtime = localStorage.getItem('user_time')
            if (strtime) {
                //计算过期时间
                let vaildtime = Number(strtime) + USERVALIDTIME
                let timespan = Date.parse(new Date())
                if (timespan < vaildtime) {
                } else {
                    this.props.saveLoginInfo(null);
                }
            }
        }
    }

    handleScroll = () => {
        let _self = this
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
        if (scrollTop > 0) {
            _self.setState({
                needFixed: true
            })
        } else {
            _self.setState({
                needFixed: false
            })
        }
    }

    setLogin = async (value) => {
        const { signView } = this.state
        this.setState({
            loading: true,
            loginLoading: true
        })
        let opts = value
        if (signView) {
            const opts = {}
            opts.captcha = value.research
            opts.mobile = value.mobile
            let list = await checkCaptcha(opts)
            if (list.code === 0) {
                let objs = {}
                // delete value.research
                objs = value
                objs.code = value.research
                let data = await doRegister(objs)
                if (data.code === 0) {
                    message.success('注册成功')
                    this.handleCancel()
                    this.setState({
                        timer: 60
                    })
                    clearInterval(this.timers)
                } else {
                    message.error(data.message)
                }
            } else {
                message.error('验证码不可使用')
            }
        } else {
            if (opts.remember) {
                localStorage.setItem('loginUser', opts.loginUser)
            } else {
                localStorage.setItem('loginUser', '')
            }
            delete opts.remember
            new Promise((resolve, reject) => {
                saveLogin(opts).then(response => {
                    if (response.code === 0) {
                        this.props.saveLoginInfo(response.data);
                        this.refs.formRef.resetFields();
                        localStorage.setItem('user_time', Date.parse(new Date()))
                        this.setState({
                            personal: '1',
                            isModalVisible: false,
                        })
                        window.location.reload();
                    } else {
                        message.error(response.message)
                    }
                    this.setState({
                        loginLoading: false,
                    })
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        }

        this.setState({
            loading: false,
            loginLoading: false
        })
    }
    testValidate = (rule, value, callback) => {
        if (rule.field === 'mobile') {
            let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
            if (!reg_tel.test(value)) {
                return callback('请填写有效手机号码');
            }
        }
        if (rule.field === 'username') {
            let reg_tel = /[A-Za-z0-9_\-\u4e00-\u9fa5]+/
            if (!reg_tel.test(value)) {
                return callback('请输入中文、英文、数字');
            }
        }
        if (rule.field === 'loginPwd') {
            let reg_tel = /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[!@#$%^&*?\(\)]).*$/
            if (!reg_tel.test(value)) {
                return callback('密码长度至少8位，至少1个大写字母、1个小写字母、1个数字和1个特殊字符!');
            }
        }
        if (rule.field === 'loginUser') {
            if (!value) {
                return callback('请填写证件号码');
            }
            let arr = []
            let flag = false
            arr.push(idCardValid(value).status)
            // arr.push(isHKCard(value).status)
            arr.push(isTWCard(value).status)
            arr.push(isPassPortCard(value).status)
            // arr.push(isOfficerCard(value).status)
            // arr.push(isAccountCard(value).status)
            if (arr.indexOf(1) == -1) {
                flag = true
            }
            if (flag == true) {
                return callback('证件号码不合规');
            }
        }
        return Promise.resolve();

    }
    getApplyTransactionChecks = async (v) => {
        let data = ''
        let list = await getApplyTransactionCheck({})
        if (list.code == 0) {
            data = '1'
            return data
        } else {
            data = '0'
            message.error(list.message)
            return data
        }
    }
    elect = async (index, item) => {
        console.log(item)
        if (item.name !== '登录' && item.name !== '注册' && item.name !== '退出' && item.name !== '资格申请' && item.name !== '续租申请') { //eslint-disable-line
            if (!userInfoFunc(this.props.userLoginInfo)) {
                if (item.links != '/home' && item.links != '/project' && item.links != '/belows' && item.links != '/policy' && item.links != '/workGuide' && item.links != '/aboutUs') {
                    message.error('请先登录')
                    return
                }
            }
            if (item.links == '/areatoraise') {
                console.log(this.props.userLoginInfo);
                if (this.props.userLoginInfo.blacklisted == '0') {
                    let type = await this.getApplyTransactionChecks(this.props.userLoginInfo.id)
                    if (type == '0') return
                }
                if (this.props.userLoginInfo.blacklisted == '1') {
                    message.error('很抱歉，您无权限')
                    return
                }
            }
            localStorage.setItem("currentIndex", item.links)
            this.setState({
                currentIndex: item.links,
                drawerVisible: false
            })
            this.props.history.push({ pathname: item.links, query: {} })
        } else {
            // eslint-disable-next-line default-case
            switch (item.name) {
                case '登录': {
                    this.setState({
                        isModalVisible: true,
                        signView: false
                    })
                    break;
                }
                case '资格申请': {
                    this.setState({
                        isApplyFor: true,
                    })
                    break;
                }
                case '续租申请': {
                    this.openRenewalModalBox()
                    break;
                }
                case '退出': {
                    this.setState({
                        loginLoading: true,
                        drawerVisible: false
                    })
                    this.loginOut()
                    break;
                }
                case '注册': {
                    this.setState({
                        isModalVisible: true,
                        signView: false
                    })
                    this.sign(true)
                    break;
                }

            }
        }
    }
    loginOut = () => {

        new Promise((resolve, reject) => {
            saveLogout().then(response => {
                if (response.code === 0) {
                    this.props.saveLoginInfo(null);
                    this.setState({
                        loginLoading: false,
                        personal: '0'
                    })
                    message.success('已退出')
                    window.location.reload();
                } else {
                    message.error(response.message)
                }
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    }
    tableBody = (item, index) => {
        const { currentIndex } = this.state
        return (
            <li key={index} >
                {
                    item.links === '/workGuide' ? 
                    <Dropdown menu={{items: this.workerGuideList}}>
                        <a onClick={(e) => e.preventDefault()} className={currentIndex == item.links ? 'elect' : ''}>
                            <Space>
                                办事指南
                                <DownOutlined />
                            </Space>
                        </a>
                    </Dropdown>
                    :
                    <a
                        className={currentIndex == item.links ? 'elect' : ''}
                        onClick={() => { this.elect(index, item) }}
                    >
                        {item.name}
                    </a>
                }
                
            </li>
        );
    }

    handleCancel = () => {
        this.setState({
            isModalVisible: false,
            isChangePassword: false,
            isApplyFor: false,
            applyForShow: false,
        })
    }
    sign = (key) => {
        this.setState({
            signView: key
        })
    }
    timersBtn = () => {
        this.timers = setInterval(() => {
            this.setState({
                timer: this.state.timer - 1
            })
            if (this.state.timer == 0) {
                clearInterval(this.timers)
                this.setState({
                    timer: 60,
                    showInter: true
                })
            }
        }, 1000)
    }
    // 忘记密码
    changePassword = () => {
        this.setState({
            isModalVisible: false,
            isChangePassword: true
        })
    }
    // 登录
    closePassword = () => {
        this.setState({
            isModalVisible: true,
            isChangePassword: false
        })
    }
    // 重设密码
    setPassword = async (value) => {
        const opts = {}
        opts.captcha = value.research
        opts.mobile = value.mobile
        let list = await checkCaptcha(opts)
        if (list.code === 0) {
            clearInterval(this.timers)
            let objs = {}
            objs = value
            objs.code = value.research
            let data = await forgetPassword(objs)
            if (data.code === 0) {
                message.success('密码修改成功')
                this.closePassword()
                this.setState({
                    timer: 60
                })
            } else {
                message.error(data.message)
            }
        } else {
            message.error('验证码不可使用')
        }
    }
    sendNationCaptcha = async () => {
        if (this.refs.formRef.getFieldValue('mobile') && this.refs.formRef.getFieldValue('mobile') != undefined) {
            // 为true的时候变为false 为false的时候不能点击
            if (!this.state.showInter) {
                message.error('请勿重复点击')
                return
            } else {
                this.setState({
                    showInter: false
                })
            }
            let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
            if (!reg_tel.test(this.refs.formRef.getFieldValue('mobile'))) {
                return
            }
            let opts = {}
            opts.mobile = this.refs.formRef.getFieldValue('mobile')
            let data = await sendNationCaptcha(opts)
            if (data?.code != 0) {
                message.error(data?.message)
            } else {
                this.timersBtn()
            }

        } else {
            message.error('请填写您的手机号码')
        }

    }
    visibleHand = () => {
        this.setState({
            drawerVisible: true
        })
    }
    onClose = () => {
        this.setState({
            drawerVisible: false,
        });
    };
    personalPushs = (tab) => {
        if (tab) {
            if (this.props.location.pathname != '/personal') {
                this.props.history.push({ pathname: '/personal', query: { tab: tab } })
            } else {
                this.props.personalPush(tab)
            }
            this.setState({
                drawerVisible: false,
            });
        }
    }
    getQueryProgressLists = () => {
        if (this.props.history.location.pathname != '/home') {
            this.props.history.push({ pathname: '/home', query: { type: 'getQueryProgressList' } })
        } else {
            this.setState({
                drawerVisible: false
            })
            this.props.getQueryProgressList()
        }
    }
    getQualificationLists = () => {
        if (this.props.history.location.pathname != '/home') {
            this.props.history.push({ pathname: '/home', query: { type: 'getQualificationList' } })
        } else {
            this.setState({
                drawerVisible: false
            })
            this.props.getQualificationList()
        }
    }
    cityLists = () => {
        this.props.history.push({ pathname: '/citylist' })
    }
    checksFunc = (e) => {
        this.setState({
            checksFunc: e
        }, () => {
            let itemName = {}
            itemName[`loginUser`] = ''
            this.refs.formRef.setFieldsValue(itemName)
        })
    }
    testValidateidno = (rule, value, callback) => {
        if (rule.field === 'loginUser') {
            if (!value) {
                return callback('请填写证件号码');
            }
            let arr = []
            let flag = false
            arr.push(idCardValid(value).status)
            if (arr.indexOf(1) == -1) {
                flag = true
            }
            if (flag == true) {
                return callback('证件号码不合规');
            }
        }
        return Promise.resolve();
    }
    testValidatePro = (rule, value, callback) => {
        if (rule.field === 'loginUser') {
            if (!value) {
                return callback('请填写证件号码');
            }
            let arr = []
            let flag = false
            arr.push(isPassPortCard(value).status)
            if (arr.indexOf(1) == -1) {
                flag = true
            }
            if (flag == true) {
                return callback('证件号码不合规');
            }
        }
        return Promise.resolve();
    }
    testValidateTW = (rule, value, callback) => {
        if (rule.field === 'loginUser') {
            if (!value) {
                return callback('请填写证件号码');
            }
            let arr = []
            let flag = false
            arr.push(isTWCard(value).status)
            if (arr.indexOf(1) == -1) {
                flag = true
            }
            if (flag == true) {
                return callback('证件号码不合规');
            }
        }
        return Promise.resolve();
    }
    testValidates = (rule, value, callback) => {
        if (rule.field === 'loginUser') {
            const { checksFunc } = this.state
            if (!checksFunc) {
                return callback('请选择证件类型');
            }
            if (!value) {
                return callback('请填写证件号码');
            }
        }
        return Promise.resolve();
    }
    showMoveBox = (type) => {
        console.log(type);
        
        if (type == '0') {
            this.setState({
                showMove: true
            })
        } else {
            this.setState({
                showMove: false
            })
        }
    }
    openRenewalModalBox = async () => {
        if (!userInfoFunc(this.props.userLoginInfo)) {
            message.error('请先登录')
            this.setState({
                isModalVisible: true,
                signView: false,
                drawerVisible: false,
            })
            return
        }
        const res = await getMyContracts('')
        if (res.code != 0) {
            message.error(res.message)
            return
        }
        const contracts = Array.isArray(res.data) ? res.data : (res.data ? [res.data] : [])
        const eligible = contracts.find((c) => c.reletFlag == null || String(c.reletFlag).trim() === '')
        if (!eligible) {
            message.error('您已提交续租申请或请于合同到期前3个月内提交续租申请。')
            return
        }
        this.setState({
            showRenewalModalBox: true,
            renewalContract: eligible,
            drawerVisible: false,
        })
    }
    changeRenewalModalBox = () => {
        this.setState({ showRenewalModalBox: false, renewalContract: null })
    }
    openLoginModal = () => {
        this.setState({
            isModalVisible: true,
            signView: false,
        })
    }

    goGuide = (type) => {
        this.props.saveGlobeParams({workGuide: type})
        if(this.props.location.pathname !== '/workGuide') {
            this.props.history.push({ pathname: '/workGuide', query: { type }  })
        }
    }

    render() {
        const { checksFunc, drawerVisible, needFixed, isModalVisible, loading, personal, loginLoading, signView, timer, isChangePassword, isApplyFor, applyForShow, showFlag, registeredType, sqTypes, showInFlag, showCheckFlag, showMove, showRenewalModalBox, renewalContract } = this.state
        return (
            <div id='topId' className={needFixed && this.props.location.pathname != '/areatoraise' ? 'backgroundFixed row fixNavView' : this.props.location.pathname == '/home' ? 'row fixNavView' : 'row rowbackgroundView'}>
                {/* v4.1.2代码注释 */}
                {/* <Modal className="applyForModal1" width={690} visible={isApplyFor} onCancel={() => { this.handleCancel() }} footer={null}>
                    <div className="applyForModal1_content">
                        <div>
                            <img src={require('../../assets/images/top-qualification2.png').default}></img>
                            <Button type="primary" onClick={() => { this.elect(2, { name: '区筹资格申请', links: '/areatoraise' }) }}>区筹资格申请</Button>
                        </div>
                        <div>
                            <img src={require('../../assets/images/top-qualification1.png').default}></img>
                            <Button type="primary" onClick={() => { this.setState({ isApplyFor: false, applyForShow: true }) }}>市筹资格申请</Button>
                        </div>
                    </div>
                </Modal>
                <Modal className="applyForModal2" width={1000} visible={applyForShow} onCancel={() => { this.handleCancel() }} footer={null}>
                    <img src={require('../../assets/images/areatoraise-three.jpg').default}></img>
                </Modal> */}
                <Modal title={!signView ? "登录" : "注册"} visible={isModalVisible} onCancel={() => { this.handleCancel() }} footer={[]} width={492} style={{ padding: '23px' }}>
                    <Form
                        name="basic"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        initialValues={{ remember: true }}
                        onFinish={(e) => { tapOnce(this.setLogin, e, 500) }}
                        ref={'formRef'}
                        autoComplete="off"
                    >
                        {!signView ? <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item label="" name="loginUser" initialValue={localStorage.loginUser ? localStorage.loginUser : ''} rules={[{ required: true, message: '' }, { validator: this.testValidate }]}>
                                    <Input placeholder="证件号码" style={{ width: '100%', height: '40px' }} />
                                </Form.Item>
                            </Col>
                        </Row> : null}

                        {!signView ? <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item label="" name="loginPwd" rules={[{ required: true, message: '请填写密码!' }, { validator: this.testValidate }]}>
                                    {/* eslint-disable-next-line react/jsx-no-undef */}
                                    <Input.Password placeholder="密码" style={{ width: '100%', height: '40px' }} />
                                </Form.Item>
                            </Col>
                            <Tooltip title="逗号，句号，顿号等不属于特殊符号，常用以下特殊符号“ ! @ $ % & * ? ”"><div style={{ position: 'absolute', top: '37%', right: '18%' }}><ExclamationCircleFilled /></div></Tooltip>

                        </Row> : null}
                        {!signView ? <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item name="remember" valuePropName="checked" >
                                    <Checkbox>记住账号</Checkbox>
                                </Form.Item>
                                <Button type="link" htmlType="button" style={{ float: 'right', margin: window.innerWidth < 576 ? "-57px 0 0px 0px" : "-57px 130px 0px 0px" }} onClick={this.changePassword}>
                                    忘记密码
                                </Button>
                            </Col>
                        </Row> : null}

                        {signView ? <div>
                            <Row>
                                <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                    <Form.Item label="" name="mobile" rules={[{ required: true, message: '未输入手机号码!' }, { validator: this.testValidate }]}>
                                        <Input placeholder="手机号码" style={{ width: '100%', height: '40px' }} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={{ span: 8, offset: 3 }} lg={{ span: 13, push: 3, offset: 0 }} sm={{ span: 13, push: 3, offset: 0 }}>
                                    <Form.Item label="" name="research" rules={[{ required: true, message: '请填写验证码!' }]}>
                                        <Input placeholder="验证码" style={{ width: '100%', height: '40px' }} />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 0 }} sm={{ span: 6, offset: 0 }}>
                                    {timer == 60 ? <Button style={{ width: '100%', height: '40px' }} onClick={() => { this.sendNationCaptcha() }}>获取验证码</Button>
                                        : <Button style={{ width: '100%', height: '40px' }} disabled={true}>{timer} S</Button>}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                    <Form.Item label="" name="cardType" initialValue={'1'} rules={[{ required: true, message: '请选择证件类型' }]}>
                                        <Select placeholder="请选择" onChange={(value) => { this.checksFunc(value) }}>
                                            <Option value='1'>大陆身份证</Option>
                                            <Option value='2'>外国护照</Option>
                                            <Option value='3'>台胞证（台湾）</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                    <Form.Item label="" name="loginUser" rules={[{ required: true, message: '' }, { validator: checksFunc == '1' ? this.testValidateidno : checksFunc == '2' ? this.testValidatePro : checksFunc == '3' ? this.testValidateTW : this.testValidates }]}>
                                        <Input placeholder="证件号码" style={{ width: '100%', height: '40px' }} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                    <Form.Item label="" name="username" rules={[{ required: true, message: '请填写手机号码!' }, { validator: this.testValidate }]}>
                                        <Input placeholder="姓名" style={{ width: '100%', height: '40px' }} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                    <Form.Item label="" name="loginPwd" rules={[{ required: true, message: '请填写密码!' }, { validator: this.testValidate }]}>
                                        <Input.Password placeholder="密码" style={{ width: '100%', height: '40px' }} />
                                    </Form.Item>
                                </Col>
                                <Tooltip title="逗号，句号，顿号等不属于特殊符号，常用以下特殊符号“ ! @ $ % & * ? ”"><div style={{ position: 'absolute', bottom: '29.5%', right: '18%' }}><ExclamationCircleFilled /></div></Tooltip>
                            </Row>
                        </div> : null}

                        <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item style={{ textAlign: 'center', lineHeight: '2em' }}>
                                    <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%', height: '48px', fontSize: '15px' }}>
                                        {!signView ? '立即登录' : '立即注册'}
                                    </Button>
                                    {!signView ? <span>
                                        没有账号？
                                        <a onClick={() => { this.sign(true) }}>立即注册</a>
                                    </span> : <span>
                                        已有账号？
                                        <a onClick={() => { this.sign(false) }}>直接登录</a>
                                    </span>}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
                <Modal title={"找回密码"} visible={isChangePassword} onCancel={() => { this.handleCancel() }} footer={[]} width={492} style={{ padding: '23px' }}>
                    <Form
                        name="basic"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        initialValues={{ remember: true }}
                        onFinish={this.setPassword}
                        ref={'formRef'}
                        autoComplete="off"
                    >
                        <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item label="" name="mobile" rules={[{ required: true, message: '未输入手机号码!' }, { validator: this.testValidate }]}>
                                    <Input placeholder="手机号码" style={{ width: '100%', height: '40px' }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={{ span: 8, offset: 3 }} lg={{ span: 13, push: 3, offset: 0 }}>
                                <Form.Item label="" name="research" rules={[{ required: true, message: '请填写验证码!' }]}>
                                    <Input placeholder="验证码" style={{ width: '100%', height: '40px' }} />
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 0 }}>
                                {timer == 60 ? <Button style={{ width: '100%', height: '40px' }} onClick={() => { this.sendNationCaptcha() }}>获取验证码</Button>
                                    : <Button style={{ width: '100%', height: '40px' }} disabled={true}>{timer} S</Button>}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item label="" name="loginPwd" rules={[{ required: true, message: '请填写新密码!' }, { validator: this.testValidate }]}>
                                    <Input.Password placeholder="新密码" style={{ width: '100%', height: '40px' }} />
                                </Form.Item>

                            </Col>
                            <Tooltip title="逗号，句号，顿号等不属于特殊符号，常用以下特殊符号“ ! @ $ % & * ? ”"><div style={{ position: 'absolute', top: '52%', right: '18%' }}><ExclamationCircleFilled /></div></Tooltip>
                        </Row>
                        <Row>
                            <Col xs={{ span: 16, offset: 3 }} sm={{ span: 24, offset: 3 }} lg={{ span: 24, offset: 3 }}>
                                <Form.Item style={{ textAlign: 'center', lineHeight: '2em' }}>
                                    <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%', height: '48px', fontSize: '15px' }}>
                                        重设密码
                                    </Button><span>
                                        想起密码？
                                        <a onClick={this.closePassword}>直接登录</a>
                                    </span>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
                {this.props?.userLoginInfo?.idno && !showRenewalModalBox ? (
                    <ModalBox showMoveBox={this.showMoveBox} enableAutoTodoCheck />
                ) : null}
                {showRenewalModalBox ? (
                    <ModalBox renewalApply renewalContract={renewalContract} changeRenewalModalBox={this.changeRenewalModalBox} />
                ) : null}
                <div className="col-lg-2"></div>
                <div className={!needFixed && this.props.location.pathname != '/home' && this.props.location.pathname != '/areatoraise' ? 'col-lg-8' : 'col-lg-8 nav-Fixed'}>
                    <nav style={{ marginBottom: '0', background: 'none', border: 'none', color: '#fff' }} className={needFixed ? 'colorFixed navbar navbar-default' : this.props.location.pathname == '/home' ? 'navbar navbar-default' : 'navbar navbar-default colorFixed'}>
                        <div className="container-fluid">
                            <div className="navbar-header" style={{ lineHeight: '60px' }}>
                                <button type="button" className="fr navbar-toggle" style={{ border: 'none', margin: '0', padding: '0 1em 0 0', background: 'none' }} data-toggle="collapse"
                                    data-target="#bs-example-navbar-collapse-1" aria-expanded="false" onClick={() => { this.visibleHand() }}>
                                    <MenuUnfoldOutlined style={{ width: '1.6em', fontSize: '1.3em' }} />
                                </button>
                                {Imgbo !== '仅供测试' ? <div id="logo"></div> : null}
                                <a className={needFixed ? 'colorFixed navbar-brand' : this.props.location.pathname == '/home' ? 'navbar-brand' : 'navbar-brand colorFixed'} style={{ height: '60px', padding: '20px 15px', color: '#fff', fontSize: '24px' }} href="/">{PAGE_NAME}</a>
                            </div>
                            <Drawer
                                title={<div style={{ fontSize: '18px' }}><div id="logoinphone"></div>宝山区公共租赁住房服务平台</div>}
                                placement={'top'}
                                height={'100%'}
                                closable={true}
                                onClose={this.onClose}
                                visible={drawerVisible}
                                key={'top'}
                            >
                                <h5 style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '2.2rem' }}>查询/办理业务</h5>
                                <Row style={{ fontSize: '1.5rem' }} gutter={[16, 16]}>
                                    <Col span={12}>
                                        <a onClick={() => { this.elect(0, { name: '首页', links: '/home' }) }}>首页 ></a>
                                    </Col>
                                    <Col span={12}>
                                        <a onClick={() => { this.elect(1, { name: '房源项目', links: '/project' }) }}>房源项目 ></a>
                                    </Col>
                                    <Col span={12}>
                                        <a onClick={() => { this.elect(1, { name: '政策法规', links: '/policy' }) }}>政策法规 ></a>
                                    </Col>
                                    <Col span={12}>
                                        <a onClick={() => { this.elect(1, { name: '办事指南', links: '/workGuide' }) }}>办事指南 ></a>
                                    </Col>
                                    <Col span={12}>
                                        <a onClick={() => { this.cityLists() }}>地图找房 ></a>
                                    </Col>
                                    <Col span={12}>
                                        <a onClick={() => { this.elect(0, { name: '续租申请', links: '' }) }}>续租申请 ></a>
                                    </Col>
                                    <Col span={12}>
                                        <a onClick={() => { this.getQueryProgressLists() }}>申请进度查询 ></a>
                                    </Col>
                                    <Col span={12}>
                                        <a onClick={() => { this.getQualificationLists() }}>查看公示名单 ></a>
                                    </Col>
                                    <Col span={12}>
                                        <a onClick={() => { this.elect(1, { name: '关于我们', links: '/aboutUs' }) }}>关于我们 ></a>
                                    </Col>
                                </Row>
                                {/*<div style={{marginTop:'3rem',paddingTop:'3rem',borderTop:'1px solid rgba(187, 187, 187, 1)'}}>*/}
                                {/*    <h5 style={{fontWeight:'bold',fontSize:'18px',marginBottom:'2.2rem'}}>辅助工具</h5>*/}
                                {/*    <Row style={{fontSize:'1.5rem'}} gutter={[16, 16]}>*/}
                                {/*        <Col span={12}>*/}
                                {/*            <a onClick={()=>{this.cityLists()}}>地图找房</a>*/}
                                {/*        </Col>*/}
                                {/*    </Row>*/}
                                {/*</div>*/}
                                <div style={{ marginTop: '3rem', paddingTop: '3rem', borderTop: '1px solid rgba(187, 187, 187, 1)' }}>
                                    {!userInfoFunc(this.props.userLoginInfo) ?
                                        <Button type={'primary'} style={{ width: '100%', height: '38px' }}
                                            onClick={() => {
                                                this.elect(3, { name: '登录', links: '' })
                                            }}>登录</Button> : null}
                                    {!userInfoFunc(this.props.userLoginInfo) ?
                                        <Button style={{ width: '100%', height: '38px', marginTop: '1.6rem' }}
                                            onClick={() => {
                                                this.elect(4, { name: '注册', links: '' })
                                            }}>注册</Button> : null}
                                    {userInfoFunc(this.props.userLoginInfo) ? <h5 style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '2.2rem' }}>个人中心</h5> : null}
                                    {userInfoFunc(this.props.userLoginInfo) ? <Row style={{ fontSize: '1.5rem' }} gutter={[16, 16]}>
                                        <Col span={12}>
                                            <a onClick={() => { this.personalPushs('0') }}>我的申请</a>
                                        </Col>
                                        <Col span={12}>
                                            <a onClick={() => { this.personalPushs('3') }}>我的账单</a>
                                        </Col>
                                        <Col span={12}>
                                            <a onClick={() => { this.personalPushs('1') }}>我的排队</a>
                                        </Col>
                                        <Col span={12}>
                                            <a onClick={() => { this.personalPushs('5') }}>消息通知</a>
                                        </Col>
                                        <Col span={12}>
                                            <a onClick={() => { this.personalPushs('6') }}>我的租情直通车</a>
                                        </Col>
                                        <Col span={12}>
                                            <a onClick={() => { this.personalPushs('2') }}>我的预约</a>
                                        </Col>
                                        <Col span={12}>
                                            <a onClick={() => { this.personalPushs('7') }}>个人资料</a>
                                        </Col>
                                        <Col span={12}>
                                            <a onClick={() => { this.personalPushs('4') }}>我的合同</a>
                                        </Col>
                                        <Col span={12}>
                                            <a onClick={() => { this.elect(4, { name: '退出', links: '' }) }} style={{ color: 'rgba(220, 37, 37, 0.85)' }}>退出登录</a>
                                        </Col>
                                    </Row> : null}
                                </div>
                            </Drawer>
                            <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                                {!loginLoading ? <ul className={needFixed ? 'colorFixed nav navbar-nav navbar-right' : this.props.location.pathname == '/home' ? 'nav navbar-nav navbar-right topLink' : 'nav navbar-nav navbar-right colorFixed'}>
                                    {homeTop.length > 0 && personal === '0' ?
                                        homeTop.map(this.tableBody)
                                        : homeTopLogin.length > 0 && personal === '1' ?
                                            homeTopLogin.map(this.tableBody)
                                            : <span className='noData'>请配置头部</span>
                                    }
                                </ul> : <Spin style={{ lineHeight: "60px" }} className={needFixed ? 'colorFixed nav navbar-nav navbar-right' : this.props.location.pathname == '/home' ? 'nav navbar-nav navbar-right topLink' : 'colorFixed nav navbar-nav navbar-right topLink'} />}
                            </div>
                        </div>
                    </nav>
                </div>
                <div className="col-lg-2"></div>
                {showMove ? <div style={{ position: 'absolute', top: 0, left: 0, width: 'auto', height: '22px', backgroundColor: 'white', lineHeight: '22px', animation: 'w_move 20s linear infinite,h_move 8s linear infinite alternate', zIndex: '10' }}>
                    <img src={require('../../assets/images/move.png').default}></img>
                </div> : null}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
        saveGlobeParams: (obj) => dispatch({type: 'SAVE_GLOBE_PARAMS', data: obj}),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Top))
